var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59755 17.6C5.388 17.6 4.40936 18.59 4.40936 19.8C4.40936 21.01 5.388 22 6.59755 22C7.8071 22 8.79673 21.01 8.79673 19.8C8.79673 18.59 7.8071 17.6 6.59755 17.6ZM17.5935 17.6C16.3839 17.6 15.4053 18.59 15.4053 19.8C15.4053 21.01 16.3839 22 17.5935 22C18.803 22 19.7926 21.01 19.7926 19.8C19.7926 18.59 18.803 17.6 17.5935 17.6ZM15.9991 12.1C16.8238 12.1 17.5495 11.649 17.9233 10.967L21.8599 3.828C22.2667 3.102 21.7389 2.2 20.9032 2.2H4.62928L3.59566 0H0V2.2H2.19918L6.15771 10.549L4.67326 13.233C3.87056 14.707 4.92617 16.5 6.59755 16.5H19.7926V14.3H6.59755L7.8071 12.1H15.9991ZM5.67389 4.4H19.0339L15.9991 9.9H8.27992L5.67389 4.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.df56e1b213eeb6cdb93aef9dc81e7aa8.svg";
export { ForwardRef as ReactComponent };